// Product fields shared by the Create Product wizard (ProductFormPage) and
// Create Related Listing.

export interface ProductContactOption {
  key: string;
  value: string;
  text: string;
}

/** Select options for the contact `names` (GET /product-contacts, see
 *  src/apis/productContacts.ts) plus any of `extra` that aren't among them
 *  (e.g. a prefilled contact who has left, or the logged-in user), so a
 *  Select can show and offer them. */
export function productContactOptionsWith(
  names: readonly string[],
  ...extra: (string | null | undefined)[]
): ProductContactOption[] {
  const options: ProductContactOption[] = names.map((name) => ({
    key: name,
    value: name,
    text: name,
  }));
  for (const name of extra) {
    const value = name?.trim();
    if (value && !options.some((o) => o.value === value)) {
      options.push({ key: value, value, text: value });
    }
  }
  return options;
}

// Same limits as ProductFormPage's Yup schema.
export const PRODUCT_TITLE_MIN_LENGTH = 8;
export const PRODUCT_TITLE_MAX_LENGTH = 250;

export function validateProductTitle(title: string): string | null {
  const trimmed = title.trim();
  if (!trimmed) return "Product Title is required";
  if (trimmed.length < PRODUCT_TITLE_MIN_LENGTH) {
    return `Product Title must be at least ${PRODUCT_TITLE_MIN_LENGTH} characters`;
  }
  if (trimmed.length > PRODUCT_TITLE_MAX_LENGTH) {
    return `Product Title must be at most ${PRODUCT_TITLE_MAX_LENGTH} characters`;
  }
  return null;
}
